export function formatDate(date) {
    return date.toLocaleDateString('de-AT', {
        weekday: 'short',
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    });
}